import { useState } from "react";
import { CheckIcon, CopyIcon } from "lucide-react";
import { Trans } from "@lingui/react/macro";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { Button } from "./button";

function InlineCode({
  className,
  children,
  ...props
}: React.ComponentProps<"code">) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const text =
      typeof children === "string"
        ? children
        : ((props as { "data-value"?: string })["data-value"] ?? "");
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error(<Trans>Kunde inte kopiera till urklipp</Trans>);
    }
  };

  return (
    <code
      {...props}
      className={cn(
        "bg-muted relative inline-flex items-center gap-1 rounded px-[0.3rem] py-[0.2rem] font-mono text-sm font-medium",
        className
      )}
    >
      {children}
      <Button type="button" variant="ghost" size="icon-xs" onClick={handleCopy}>
        {copied ? <CheckIcon /> : <CopyIcon />}
      </Button>
    </code>
  );
}

export { InlineCode };
